import type { EmptyObject } from '@change-corgi/core/types';

import { SectionSeparator } from 'src/app/pages/petitionDetails/shared/components';

import { SECTION_ID_MAPPING, useScrollToSection } from '../../hooks/useScrollToSection';

import { SignaturesDistributionContainerSunrise } from './components/SignaturesDistributionContainerSunrise';
import { SupporterVoices } from './components/supportersVoices';
import { TheSupportersTitle } from './components/TheSupportersTitle';
import { TheSupportersContextProvider, useTheSupportersContext } from './shared/context';

const TheSupportersInner: React.FC<EmptyObject> = () => {
	const {
		data: { hasContent, hasComments, hasVideos, hasMap },
	} = useTheSupportersContext();

	const {
		data: { refs },
	} = useScrollToSection();

	if (!hasContent) {
		return <div className="hidden" data-testid="petition-page-supporters-section-hidden" />;
	}

	return (
		<div id={SECTION_ID_MAPPING.SUPPORTER_VOICES} ref={refs[SECTION_ID_MAPPING.SUPPORTER_VOICES]}>
			<SectionSeparator />
			<div className="mb-6 lg:mb-16">
				{hasComments || hasVideos ? (
					<>
						<TheSupportersTitle />
						<SupporterVoices />
					</>
				) : null}
				{hasMap ? <SignaturesDistributionContainerSunrise /> : null}
			</div>
		</div>
	);
};

export const TheSupportersSunrise: React.FC<EmptyObject> = () => {
	return (
		<TheSupportersContextProvider>
			<TheSupportersInner />
		</TheSupportersContextProvider>
	);
};
